import * as angular from "angular";
import {IController, IQService, IScope} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {PricePlanAlertsService} from "../../services/price-plan-alerts.service";
import {ServiceTimeDialogService} from "../../services/service-time-dialog-service.service";
import {ServiceTimeRequestsService} from "../../services/service-time-requests.service";

export class PricePlanCalendarComponent implements IController {
  programId: any;

  public serviceTimeActions = ["Edit", "Duplicate", "Remove"];
  public specialDayActions = ["Edit", "Remove"];
  public serviceTimeDays = [];
  public specialDays = [];
  public isLoading = false;
  public eventSources = [
    {
      events: []
    }
  ];
  public query = {
    type: null,
    from: null,
    to: null,
    zoneId: null
  };
  public formatBy: any;
  public config: any;
  public currentDay: any;
  public currentView: any;
  public calendarOptions: any;


  public events: any[];
  public views: any[];
  public slotLabelInterval: string;
  public slotDuration: string;

  constructor(private pricePlanAlertsService: PricePlanAlertsService, private uiCalendarConfig, private serviceTimeRequestsService: ServiceTimeRequestsService, private $scope: IScope, private bringozLoaderService: BringozLoaderService,
              private pricePlanConstant, private $q: IQService, private serviceTimeDialogService: ServiceTimeDialogService, private $log, private splitService: SplitService,
              private $compile, private $filter, private moment, private commonsDialogService: CommonsDialogService, private commonsService: CommonsService) {
    this.formatBy = _.isEqual(this.splitService.getCountryCode(), 'US') ? 'US' : 'all';
    this.config = angular.copy(this.pricePlanConstant.serviceTime);
    this.events = [];
    this.views = ['month', 'agendaWeek', 'agendaDay'];
    this.slotLabelInterval = this.config.slotLabelInterval;
    this.slotDuration = this.config.slotDuration;
    // this.calendarOptions = {
    //   header: this.config.header,
    //   customButtons: {
    //     specialDay: {
    //       text: 'Special Day',
    //       click: this.addSpecialDay.bind(this)
    //     },
    //     serviceTime: {
    //       text: 'Service Time',
    //       click: this.addServiceTime.bind(this)
    //     }
    //   },
    //   buttonText: this.config.buttonText,
    //   // contentHeight: 'auto',
    //   allDaySlot: false,
    //   displayEventEnd: true,
    //   defaultView: this.config.defaultView,
    //   columnFormat: this.config.formats.date.columnTitle[this.formatBy],
    //   slotLabelInterval: this.config.slotLabelInterval,
    //   slotDuration: this.config.slotDuration,
    //   slotLabelFormat: this.config.formats.time[this.formatBy],
    //   timeFormat: this.config.formats.time[this.formatBy],
    //   firstDay: 0, //As integer.
    //
    //   viewRender: this.viewRender.bind(this),
    //   eventRender: this.eventRender.bind(this),
    //   eventDrop: this.handleResizeAndDrop.bind(this),
    //   eventResize: this.handleResizeAndDrop.bind(this),
    //   eventClick: this.eventClick.bind(this),
    //   viewDestroy: this.removeAllEventsFromCalendar.bind(this)
    // };
  }

  $onInit() {
    this.query.zoneId = this.splitService.getTimeZone();
  }

  setLoader(state) {
    this.isLoading = state;
    if (state) {
      this.bringozLoaderService.on();
    } else {
      this.bringozLoaderService.off();
    }
  }

  onViewRender(start, end, view) {
    this.currentDay = start.toDate();

    this.query.from = start.valueOf();
    this.query.to = end.valueOf();

    _.isEqual(view.name, 'month') ? this.getSpecialDaysData() : this.getServiceTimeAndSpecialDaysData();
  }

  eventRender(event, element, view) {
    const day = event.$$day,
      label = day.slot.label,
      parentLabel = day.slot.parentLabel,
      dayType = day.isSpecialDay ? 'specialDay' : 'serviceTime',
      slotType = this.isParent(event.$$day.slot) ? 'inherit' : 'override',
      date = this.$filter('date')(day.date, this.config.formats.date.tooltip[this.formatBy]),
      start = this.$filter('date')(event.start.valueOf(), this.config.formats.time[this.formatBy]),
      end = this.$filter('date')(event.end.valueOf(), this.config.formats.time[this.formatBy]);

    const tooltip = angular.element('<md-tooltip md-direction="top"><span ng-non-bindable></span></md-tooltip>');
    const tooltipContent = tooltip[0].querySelector('span');
    const tooltipLines = [
      this.config.tooltip.header[dayType][slotType],
      !_.isUndefined(label) ? label : (!_.isUndefined(parentLabel) ? parentLabel : undefined),
      day.dayOfWeek + ' - ' + date,
      start + ' - ' + end
    ];

    _.forEach(tooltipLines, (line, index) => {
      if (_.isUndefined(line)) {
        return;
      }

      if (index > 0 && tooltipContent.childNodes.length) {
        tooltipContent.appendChild(document.createElement('br'));
      }

      tooltipContent.appendChild(document.createTextNode(String(line)));
    });

    element.append(tooltip);
    this.$compile(tooltip)(this.$scope);
  }

  onEventClick(calEvent, jsEvent, view) {

    if (calEvent.editable && !this.isLoading) {

      const actions = calEvent.$$day.isSpecialDay ? this.specialDayActions : this.serviceTimeActions;

      this.commonsService.openActionPanel(actions, jsEvent)
        .then((reason) => {
          if (reason === 'Edit') {
            this.onEdit(calEvent, jsEvent);
          }
          //only for service time
          if (reason === 'Duplicate') {
            this.onDuplicate(calEvent);
          }
          if (reason === 'Remove') {
            this.onRemove(calEvent, jsEvent);
          }
        })
        .catch((reason) => {
            this.$log.info('Action Panel Closed', reason);
          }
        )
      ;

    } else {
      this.$log.error('Day not found! \n ' +
        '-->CalendarController@eventClick');
    }

  }

  onEventChange(event, delta, revertFunc, jsEvent, ui, view) {

    if (event.isDragAndDropEnabled && !this.isLoading && this.isEventTimeValid(event)) {

      const day = event.$$day.isSpecialDay ? this.getSpecialDayByEvent(event) : this.getServiceTimeByEvent(event),
        isSpecialDay = event.$$day.isSpecialDay;

      this.updateEvent(event).then(
        (data) => {
          isSpecialDay ? this.handleSpecialDayCreateUpdate(data, day) :
            this.handleServiceTimeCreateUpdate(data, day);
        }).catch(() => revertFunc());
    } else {
      revertFunc();
    }
  }

  removeAllEventsFromCalendar() {
    // this.uiCalendarConfig.calendars['calendar'].fullCalendar('removeEvents');
    this.events = [];
  }

  addSpecialDay($event) {
    this.serviceTimeDialogService.addSpecialDayEvent(this.programId, this.specialDays, this.currentDay.valueOf(), this.query, $event).then(
      (data) => {
        this.handleSpecialDayCreateUpdate(data.specialDays, data.updatedDay);
      }
    ).catch((error) => this.$log.error(error));
  }

  addServiceTime($event) {
    this.serviceTimeDialogService.addServiceTimeEvent(this.programId, this.serviceTimeDays, this.currentDay.valueOf(), this.query, $event).then(
      (data) => {
        this.handleMultipleServiceTimeCreateUpdate(data.serviceTime, data.updatedDays);
      }
    ).catch((error) => this.$log.error(error));
  }

  private onEdit(calEvent, jsEvent) {

    const isSpecialDay = calEvent.$$day.isSpecialDay,
      day = isSpecialDay ? this.getSpecialDayByEvent(calEvent) : this.getServiceTimeByEvent(calEvent);

    if (day) {
      this.serviceTimeDialogService.editEvent(this.programId, day, calEvent, jsEvent, this.query).then(
        (data) => {
          isSpecialDay ? this.handleSpecialDayCreateUpdate(data, day) :
            this.handleServiceTimeCreateUpdate(data, day);
        }
      ).catch((error) => this.$log.error(error));
    }
  }

  private onDuplicate(calEvent) {

    this.serviceTimeDialogService.duplicateServiceTimeDay(calEvent, this.serviceTimeDays, this.programId, this.query)
      .then((data) => {
        this.handleMultipleServiceTimeCreateUpdate(data.serviceTime, data.updatedDays);
      })
  }

  private handleMultipleServiceTimeCreateUpdate(serviceTime, updatedDays) {
    this.serviceTimeDays = serviceTime;


    _.forEach(updatedDays, (ud) => {
      const updatedDay = _.find(serviceTime, (std) => {
        return std.id === ud.id;
      })

      this.removeEventsByDay(updatedDay);
      this.createEventsByDay(updatedDay, false, this.config.events.isEditable.serviceTime);
      this.setLoader(false);

    })

    this.pricePlanAlertsService.updateServiceTimeSuccess();
  }

  private onRemove(calEvent, jsEvent) {

    const isSpecialDay = calEvent.$$day.isSpecialDay;
    _.set(calEvent.$$day.slot, 'enabled', undefined);


    const dayCopy = calEvent.$$day.isSpecialDay ? this.getSpecialDayByEvent(calEvent) : this.getServiceTimeByEvent(calEvent);
    dayCopy.dayChunks.splice(calEvent.$$day.slotIndex, 1);

    const request = calEvent.$$day.isSpecialDay ? 'updateCreateSpecialDay' : 'updateCreateServiceTime';
    this.isLoading = true;
    this.serviceTimeRequestsService[request](this.programId, dayCopy)
      .then((data) => {
        isSpecialDay ? this.handleSpecialDayCreateUpdate(data, dayCopy) :
          this.handleServiceTimeCreateUpdate(data, dayCopy);
      })
      .finally(() => {
        this.isLoading = false;
      })

  }

  private getServiceTimeByEvent(event) {
    return this.serviceTimeDays.find((serviceTime) => {
      return _.isEqual(serviceTime.id, event.$$day.id);
    });
  }

  private getSpecialDayByEvent(event) {
    return this.specialDays.find((specialDay) => {
      return _.isEqual(specialDay.id, event.$$day.id);
    });
  }

  private isEventTimeValid(event) {
    const start = event.start,
      end = event.end;

    return _.isEqual(end.hour(), 0) ? true : _.isEqual(end.date(), start.date());
  }

  private handleServiceTimeCreateUpdate(serviceTimeDays, day) {
    this.serviceTimeDays = serviceTimeDays;

    const updatedDay = _.find(serviceTimeDays, (dayOfWeek) => {
      return _.isEqual(dayOfWeek.id, day.id);
    });

    this.removeEventsByDay(updatedDay);

    this.createEventsByDay(updatedDay, false, this.config.events.isEditable.serviceTime);

    this.setLoader(false);

    this.pricePlanAlertsService.updateServiceTimeSuccess();
  }

  private handleSpecialDayCreateUpdate(specialDays, day) {
    this.specialDays = specialDays;

    const updatedDay = _.find(specialDays, (dayOfWeek) => {
      return _.isEqual(dayOfWeek.id, day.id);
    });

    this.removeEventsByDay(updatedDay);

    this.createEventsByDay(updatedDay, true, this.config.events.isEditable.specialDay);

    this.setLoader(false);

    this.pricePlanAlertsService.updateSpecialDaySuccess();
  }

  private removeEventsByDay(day) {
    this.uiCalendarConfig.calendars['calendar'].fullCalendar('removeEvents', (event) => {
      return _.isEqual(event.$$day.id, day.id) && _.isEqual(event.$$day.type, day.type);
    });
  }

  private updateEvent(event) {
    const deferred = this.$q.defer(),
      day = event.$$day.isSpecialDay ? this.getSpecialDayByEvent(event) : this.getServiceTimeByEvent(event);

    this.setLoader(true);

    if (day) {

      event.$$day.slot.from = event.start.hour(); //Moment object.
      event.$$day.slot.to = event.end.hour(); //Moment object.

      const dayCopy = angular.copy(day);

      dayCopy.dayChunks.splice(event.$$day.slotIndex, 1);
      dayCopy.dayChunks.push({
        from: event.$$day.slot.from,
        to: event.$$day.slot.to,
        enabled: _.get(event.$$day.slot, 'enabled'),
        commission: _.get(event.$$day.slot, 'commission'),
        priceExtra: _.get(event.$$day.slot, 'priceExtra'),
        priceFactor: _.get(event.$$day.slot, 'priceFactor')
      });

      const request = event.$$day.isSpecialDay ? 'updateCreateSpecialDay' : 'updateCreateServiceTime';
      this.serviceTimeRequestsService[request](this.programId, dayCopy, this.query).then(
        (data) => {
          this.setLoader(false);
          deferred.resolve(data);
        }
      ).catch(() => deferred.reject);

    } else {
      this.$log.error('Service Time not found! \n ' +
        '-->CalendarController@updateEvent');
      deferred.reject();
      this.setLoader(false);
    }

    return deferred.promise;
  }

  private setSpecialDaysEvents(specialDays) {
    if (this.config.events.isSpecialDaysEnabled) {
      this.specialDays = specialDays;
      _.forEach(specialDays, (day) => {
        this.createEventsByDay(day, true, this.config.events.isEditable.specialDay);
      });
    }
  }

  private getSpecialDaysData() {
    const deferred = this.$q.defer();
    this.setLoader(true);

    this.serviceTimeRequestsService.getSpecialDays(this.programId, this.query).then(
      (data) => {
        this.removeAllEventsFromCalendar();
        this.setSpecialDaysEvents(data);
        this.setLoader(false);

        deferred.resolve();
      }
    ).catch(() => deferred.reject);

    return deferred.promise;
  }


  private getServiceTimeAndSpecialDaysData() {
    this.setLoader(true);

    this.serviceTimeRequestsService.getServiceTimeAndSpecialDaysData(this.programId, this.query).then(
      (data) => {

        this.removeAllEventsFromCalendar();

        if (this.config.events.isServiceTimeEnabled) {
          this.serviceTimeDays = data.serviceTime;
          _.forEach(data.serviceTime, (day) => {
            this.createEventsByDay(day, false, this.config.events.isEditable.serviceTime);
          });
        }

        if (this.config.events.isSpecialDaysEnabled) {
          this.specialDays = data.specialDays;
          _.forEach(data.specialDays, (day) => {
            this.createEventsByDay(day, true, this.config.events.isEditable.specialDay);
          });
        }

        this.setLoader(false);

      }
    ).catch((error) => this.$log.error(error))
  }

  private createEventsByDay(day, isSpecialDay, isEditable) {
    const slots = day.dayChunks;

    _.forEach(slots, (slot, index) => {
      if (_.isEqual(this.config.events.blockByState.indexOf(slot.state), -1)) {
        this.createEventBySlot(day, slot, index, isSpecialDay);
      }
    });
  }

  private createEventBySlot(day, slot, index, isSpecialDay) {
    const slotType = isSpecialDay ? 'specialDay' : 'serviceTime';
    const event = {
      //Bringoz service time / special day data.
      $$day: {
        id: day.id, //used for filtering.
        dayOfWeek: day.dayOfWeek,
        type: day.type,
        date: day.date,
        slotIndex: index, //Used for replacement of the old 'dayChunk'.
        isSpecialDay: isSpecialDay, //As indication, used for the request to the server (ServiceTime/SpecialDay).
        slot: angular.copy(slot) //Data.
      },

      //Calendar event configuration (UI-Calendar).
      allDay: false,
      editable: this.isSlotEditable(slot),
      isDragAndDropEnabled: this.config.events.isDragAndDropEnabled[slotType],
      className: this.config.colorScheme.classes[slotType],
      start: this.generateMomentTimeObject(day.date, slot.from),
      end: this.generateMomentTimeObject(day.date, slot.to)
    };

    const colorScheme = this.serviceTimeRequestsService.getEventColorScheme(isSpecialDay, slot.state);
    this.events.push(_.merge(event, colorScheme));
  }

  private isSlotEditable(slot) {
    return !_.isEqual(this.config.events.isEditable.indexOf(slot.state), -1);
  }

  private isParent(slot) {
    return !_.isEqual(this.config.events.isParent.indexOf(slot.state), -1);
  }

  private generateMomentTimeObject(date, time) {
    //Time is a double.
    const timeParsed = time.toFixed(2).split('.'), //Split hours and minutes apart.
      hours = parseInt(timeParsed[0]),
      minutes = timeParsed[1] ? parseInt((parseInt(timeParsed[1]) / 100 * 60).toFixed()) : 0; //Multiply by 6 to convert to minutes.

    return this.moment(date).set(_.isEqual(time, 24) ? {
      hours: 23,
      minutes: 59,
      second: 59,
      millisecond: 999
    } : {hours: hours, minutes: minutes});
  }


}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanCalendar', {
    bindings: {
      programId: '<'
    },
    template: require('./price-plan-calendar.html').default,
    controller: PricePlanCalendarComponent
  });
